import {Injectable} from '@angular/core';
import {SecureApi} from '../core/secure.api';

@Injectable()
export class ActivityDashboardService {
    TRACKING              = 'tracking';
    GENERAL              = 'general';
    SELF_REPORT           = 'self_report';
    REPEATED_SR           = 'repeated_sr';
    COMPARE_ACTION        = 'compare_action';
    CLINIC_VALIDATION     = 'clinic_validation';
    PROPOSAL              = 'proposal';
    DOWNLOAD              = 'download';
    SERVICE_PROVIDER_ACTION   = 'service_provider_action';

    SUPERADMIN_DASHBOARD = [
        this.GENERAL,
        this.TRACKING,
        this.SELF_REPORT,
        this.CLINIC_VALIDATION,
        this.PROPOSAL,
        this.REPEATED_SR,
        this.COMPARE_ACTION,
        this.DOWNLOAD,
        this.SERVICE_PROVIDER_ACTION
    ];
    constructor(public secureApi: SecureApi) {
    }
    /**
     * @param {string} currentUrl
     * @param {number} currentPage
     * @param {number} itemsPerPage
     * @param {string} sortedColumn
     * @param {string} order
     * @param searchInfo
     * @returns {Observable<any>}
     */
    getItems(currentUrl: string, dateOptionsFilter: any, currentPage: number, itemsPerPage: number, sortedColumn: string, order: string, clinicId?, searchInfo?: any, index?: number) {
        let url = currentUrl + '/index?filters=';
        let sortFilter = 'sort-' + sortedColumn + '--order-' + order;
        let queryParams = '&page=' + currentPage + '&items=' + itemsPerPage;
        queryParams += '&startDate=' + dateOptionsFilter.from.format('YYYY-MM-DD') + '&endDate=' + dateOptionsFilter.to.format('YYYY-MM-DD');
        queryParams += '&clinicId=' + clinicId;
        const section = this.SUPERADMIN_DASHBOARD[index] || null;
        queryParams += section ? '&section=' + section : '';
        // add url query parameters based on the availability of the searches
        // if (searchInfo) {
        //     let isFirstFilter = true;
        //     for (let key in searchInfo) {
        //         if (searchInfo.hasOwnProperty(key) && searchInfo[key]) {
        //             if (isFirstFilter) {
        //                 isFirstFilter = false;
        //             } else {
        //                 url += '--';
        //             }
        //             url += key + '-' + searchInfo[key];
        //         }
        //     }
        //     url += '--' + sortFilter + queryParams;
        // } else {
            url += sortFilter + queryParams;
        // }

        // return users from backend in json format
        return this.secureApi.get(url);
    }
}
